import HorizontalScrollList from './HorizontalScrollList';

export default HorizontalScrollList;
